import { useSpring, a } from '@react-spring/web';
import clsx from 'clsx';
import * as React from 'react';

import bg01compat from '@/assets/backgrounds/bg01.jpg';
import bg01 from '@/assets/backgrounds/bg01.webp';
import { Fade } from '@/components/Animations';
import { ChainDivider } from '@/components/Elements/ChainDivider';
import { Footer } from '@/components/Elements/Footer';
import { Grain } from '@/components/Elements/Grain';
import { Logo } from '@/components/Elements/Logo';
import { PageTitle } from '@/components/Elements/PageTitle';
import { SocialShare } from '@/components/Elements/SocialShare';
import { isWebpSupport } from '@/utils/image';

import { Head } from '../Head';
import { MobileMenu } from '../MobileMenu';
import { Navigation } from '../Navigation';

const AnimatedChainDivider = () => {
  const spring = useSpring({
    from: { width: '0%' },
    to: { width: '100%' },
    delay: 300,
  });
  return (
    <a.div style={spring}>
      <ChainDivider />
    </a.div>
  );
};

const LeftToRightTransition = ({ children }: { children: React.ReactNode }) => {
  const spring = useSpring({
    from: { opacity: 0, transform: 'translateX(-80px)' },
    to: { opacity: 1, transform: 'translateX(0%)' },
    delay: 500,
  });
  return <a.div style={spring}>{children}</a.div>;
};
type ContentLayoutProps = {
  children: React.ReactNode;
  title: string;
  subtitle: string;
};
export const ContentLayout = ({ children, title, subtitle }: ContentLayoutProps) => {
  const [faded, setFaded] = React.useState(false);
  return (
    <>
      <Head title={`${title} | TVアニメ「見知らぬ女子高生に監禁された漫画家の話」特設サイト`} />
      {!faded && (
        <Fade
          type="fade-out"
          className={clsx('fixed top-0 left-0 w-full h-full bg-black z-20 pointer-events-none')}
          springProps={{ config: { duration: 800 } }}
          onFinishFade={() => setFaded(true)}
        />
      )}
      <div className="flex m-5 md:m-10 justify-around align-middle z-10">
        <PageTitle title={title} subtitle={subtitle} />
        <Navigation className="hidden md:flex flex-wrap md:ml-5 w-[50%] lg:w-auto justify-center" />
        <div className="hidden md:flex">
          <SocialShare />
        </div>
      </div>
      <AnimatedChainDivider />
      <div className="absolute w-full h-40 bg-gradient-to-b from-black to-transparent" />
      <div
        className="bg-fixed bg-cover bg-center flex flex-col"
        style={{ backgroundImage: `url(${isWebpSupport ? bg01 : bg01compat})` }}
      >
        <Grain />
        <div className="hidden md:flex fixed min-w-[9rem] max-w-[10%] z-10 pt-10">
          <Logo className="max-h-[50%] m-auto" />
        </div>
        <LeftToRightTransition>
          <main
            className={clsx(
              'min-w-[80%] md:min-w-[90%] xl:px-[10%] min-h-[80vh] self-center z-10',
              'md:ml-[9rem] py-10 px-4 sm:px-6 md:px-8 m-auto'
            )}
          >
            {children}
          </main>
        </LeftToRightTransition>
        <Footer className="absolute bottom-0 w-full z-10" />
      </div>
      <MobileMenu />
    </>
  );
};
